import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import NotificationsList from '../components/NotificationsList';


export default function initCartNotification(selector, store) {
    const elem = document.querySelector(selector);
    if (!elem) {
        return;
    }
    ReactDOM.render(
        <Provider store={store}>
            <NotificationsList />
        </Provider>, elem);
}



// WEBPACK FOOTER //
// ./src/widgets/Notifications.js